module.exports = __webpack_public_path__ + "static/media/double-right-arrow.f6cc5b7b.svg";